import { render, staticRenderFns } from "./poswrapper.vue?vue&type=template&id=41d9c09d&"
import script from "./poswrapper.vue?vue&type=script&lang=js&"
export * from "./poswrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports